import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';

@Component({
  selector: 'measure-canvas',
  template: '<canvas #myCanvas width="1000" height="800"></canvas>',
  styles: [':host {height:100%; width: 100%;}'],
})
export class MeasureCanvas implements AfterViewInit {
  @ViewChild('myCanvas') canvas: ElementRef;

  public context: CanvasRenderingContext2D; // la zone de dessin
  public yCoord: number = 10;

  constructor() {}

  ngAfterViewInit() {
    const canvas = this.canvas.nativeElement;
    this.context = canvas.getContext('2d');

    this.context.fillStyle = '#892034';
    // this.tick();
    this.move(this.yCoord * 10, 10, this.context);

    // this.context.fillRect(50, this.yCoord * 10, 30, 30);
  }

  move(y: number, z: number, ctx: CanvasRenderingContext2D) {
    console.log('move ', y, ctx);
    const max = ctx.canvas.width / z;
    const canvas = ctx.canvas;
    let x = 0;
    const i = setInterval(() => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.draw(x, y, z, ctx);
      x = x + 2 * this.yCoord;
      if (x >= max) {
        clearInterval(i);
      }
    }, 20);
  }

  draw(x: number, y: number, z: number, ctx: CanvasRenderingContext2D) {
    ctx.fillRect(z * x, z * y, z, z);
  }
}
